<template>
  <div>
    <div
      v-if="redirect === 'whatsapp'"
      :class="$style.actionTypeWidgetPreviewWhatApp"
    >
      <svg
        :class="$style.actionTypeWidgetPreviewWhatAppIcon"
        width="32"
        height="32"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.7501 5.18334C25.6334 2.05001 21.4834 0.333344 17.0667 0.333344C7.96675 0.333344 0.550082 7.75001 0.550082 16.85C0.550082 19.7667 1.31675 22.6 2.75008 25.1L0.416748 33.6667L9.16675 31.3667C11.5834 32.6833 14.3001 33.3833 17.0667 33.3833C26.1667 33.3833 33.5834 25.9667 33.5834 16.8667C33.5834 12.45 31.8667 8.30001 28.7501 5.18334ZM17.0667 30.5833C14.6001 30.5833 12.1834 29.9167 10.0667 28.6667L9.56675 28.3667L4.36675 29.7333L5.75008 24.6667L5.41675 24.15C4.05008 21.9667 3.31675 19.4333 3.31675 16.85C3.31675 9.28334 9.48341 3.11668 17.0501 3.11668C20.7167 3.11668 24.1667 4.55001 26.7501 7.15001C29.3501 9.75001 30.7667 13.2 30.7667 16.8667C30.8001 24.4333 24.6334 30.5833 17.0667 30.5833ZM24.6001 20.3167C24.1834 20.1167 22.1501 19.1167 21.7834 18.9667C21.4001 18.8333 21.1334 18.7667 20.8501 19.1667C20.5667 19.5833 19.7834 20.5167 19.5501 20.7833C19.3167 21.0667 19.0667 21.1 18.6501 20.8833C18.2334 20.6833 16.9001 20.2333 15.3334 18.8333C14.1001 17.7333 13.2834 16.3833 13.0334 15.9667C12.8001 15.55 13.0001 15.3333 13.2167 15.1167C13.4001 14.9333 13.6334 14.6333 13.8334 14.4C14.0334 14.1667 14.1167 13.9833 14.2501 13.7167C14.3834 13.4333 14.3167 13.2 14.2167 13C14.1167 12.8 13.2834 10.7667 12.9501 9.93334C12.6167 9.13334 12.2667 9.23334 12.0167 9.21668C11.7667 9.21668 11.5001 9.21668 11.2167 9.21668C10.9334 9.21668 10.5001 9.31668 10.1167 9.73334C9.75008 10.15 8.68341 11.15 8.68341 13.1833C8.68341 15.2167 10.1667 17.1833 10.3667 17.45C10.5667 17.7333 13.2834 21.9 17.4167 23.6833C18.4001 24.1167 19.1667 24.3667 19.7667 24.55C20.7501 24.8667 21.6501 24.8167 22.3667 24.7167C23.1667 24.6 24.8167 23.7167 25.1501 22.75C25.5001 21.7833 25.5001 20.9667 25.3834 20.7833C25.2667 20.6 25.0167 20.5167 24.6001 20.3167Z"
          fill="white"
        />
      </svg>
    </div>
    <div
      v-else-if="redirect === 'telegram'"
      :class="$style.actionTypeWidgetPreviewTelegram"
    >
      <svg
        :class="$style.actionTypeWidgetPreviewTelegramIcon"
        width="30"
        height="26"
        viewBox="0 0 30 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.8358 16.8967L11.3495 23.7371C12.0453 23.7371 12.3467 23.4382 12.708 23.0793L15.9702 19.9617L22.7298 24.9119C23.9695 25.6028 24.8429 25.239 25.1773 23.7714L29.6143 2.98073L29.6155 2.97951C30.0087 1.14691 28.9528 0.430284 27.7449 0.879858L1.66467 10.8648C-0.115252 11.5557 -0.0883025 12.548 1.3621 12.9976L8.02977 15.0715L23.5174 5.38051C24.2463 4.89786 24.909 5.16491 24.3639 5.64756L11.8358 16.8967Z"
          fill="white"
        />
      </svg>
    </div>
    <img
      v-else-if="redirect === 'whatsapp-and-telegram'"
      src="@/assets/mixed-logo.gif"
      alt=""
      :class="$style.actionTypeWidgetPreviewIcon"
    >

    <slot />
  </div>
</template>

<script>
export default {
  props: {
    redirect: {
      type: String,
      default: 'whatsapp'
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.actionTypeWidgetPreviewIcon {
  --s: 56px;

  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: var(--s);
  height: var(--s);
}

.actionTypeWidgetPreview {
  --s: 56px;

  all: unset;
  display: block;
  width: var(--s);
  height: var(--s);
  position: absolute;
  bottom: 40px;
  right: 40px;
  border-radius: 50%;
}

.actionTypeWidgetPreviewWhatApp,
.actionTypeWidgetPreviewTelegram {
  --s: 56px;

  all: unset;
  display: flex;
  width: var(--s);
  height: var(--s);
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    top: 3px;
    left: 3px;
    border-radius: 50%;
  }
}

.actionTypeWidgetPreviewWhatApp {
  background: linear-gradient(0deg, #25d366 0%, #84ffb2 100%);

  &::before {
    background-color: #25d366;
  }
}

.actionTypeWidgetPreviewTelegram {
  background: linear-gradient(0deg, #08c 0%, #5dccff 100%);

  &::before {
    background-color: #08c;
  }
}

.actionTypeWidgetPreviewTelegramIcon {
  position: relative;
  z-index: 1;
  margin-left: -3px;
  margin-top: 2px;
}

.actionTypeWidgetPreviewWhatAppIcon {
  position: relative;
  z-index: 1;
}
</style>
